// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleImageBanner_container__DFnMe","img":"SingleImageBanner_img__pobSb"};